import type { Ceremony, ScheduleEvent, WeddingData } from '@/mock/types'
import { placeEvent } from '../schedule/model'

export type CeremonyBasics = {
  kind: Ceremony['kind']
  venueSupplierId: string | null
  location: string
  time: string
  endTime: string
}

export type CeremonyBasicsErrors = Partial<Record<'location' | 'time' | 'endTime', string>>

export function ceremonyBasics(data: WeddingData): CeremonyBasics {
  const event = data.schedule.find((item) => item.source?.section === 'ceremony')
  return {
    kind: data.ceremony.kind,
    venueSupplierId: data.ceremony.venueSupplierId,
    location: event?.location ?? '',
    time: event?.time ?? '',
    endTime: event?.endTime ?? '',
  }
}

export function validateCeremonyBasics(draft: CeremonyBasics): CeremonyBasicsErrors {
  const errors: CeremonyBasicsErrors = {}
  if (draft.location.trim().length > 300)
    errors.location = 'Název prostoru může mít nejvýše 300 znaků.'
  for (const field of ['time', 'endTime'] satisfies (keyof CeremonyBasicsErrors)[]) {
    if (draft[field] && !/^([01]\d|2[0-3]):[0-5]\d$/.test(draft[field]))
      errors[field] = 'Zadejte čas ve formátu HH:mm, například 14:00.'
  }
  return errors
}

export function saveCeremonyBasics(
  data: WeddingData,
  draft: CeremonyBasics,
  newEventId: string,
): WeddingData {
  const existing = data.schedule.find((item) => item.source?.section === 'ceremony')
  const location = draft.location.trim()
  const hasEvent = existing || draft.venueSupplierId || location || draft.time || draft.endTime
  const event: ScheduleEvent | undefined = hasEvent
    ? {
        id: newEventId,
        title: 'Obřad',
        description: '',
        audience: 'guests',
        dayPartId: data.dayParts.find((part) => part.id === 'ceremony')?.id ?? null,
        source: { section: 'ceremony', label: 'Obřad' },
        removed: false,
        ...existing,
        location,
        time: draft.time || null,
        endTime: draft.endTime || null,
      }
    : undefined
  return {
    ...data,
    ceremony: { ...data.ceremony, kind: draft.kind, venueSupplierId: draft.venueSupplierId },
    schedule: event ? placeEvent(data.schedule, event) : data.schedule,
  }
}
